import { render, staticRenderFns } from "./CoursesSectionAdmin.vue?vue&type=template&id=1b6420c6"
import script from "./CoursesSectionAdmin.vue?vue&type=script&lang=js"
export * from "./CoursesSectionAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports